// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6hgbl","right":"styles_right__3jl7c"};